// ModalEventLink.js

import React from 'react';

class ModalEventLink extends React.Component {
  closeModal = () => {
    this.props.closeModal();
  }

  render() {
    return (
      <div className="modal">
        <div className="modal-content new">
            {this.props.isLoading && (
              <div className="loading">
                <div className="spinner-border text-primary" role="status">
                  <span className="sr-only">Loading...</span>
                </div>
              </div>
            )}
          <span className="close text-black text-right" onClick={this.closeModal}>&times;</span>
          <div className='iframe-container'>
            <iframe className='iframe-link' title="Dynamic Content" src={this.props.iframeSrc} width="100%" height="100%"></iframe>
          </div>
        </div>
      </div>
    );
  }
}

export default ModalEventLink;
